// Figma: no frame provided yet — built using the established design system per the
// "extrapolate" decision.
// LOGIC PORTED from LC2's EngagementStakeVisaStats.js (commons/components/HomeTabs/
// Engagement/): same shape ({title, items: [{metric, label}], data: {name: value},
// labels: {name: displayValue}, colors: {name: hex}}), same "render nothing when no data"
// behavior, same colored-swatch legend rows.
// SIMPLIFIED: LC2 rendered a recharts stacked BarChart of `data`. recharts isn't a
// dependency of this app (see rules re: not adding a charting lib unless needed) — the
// legend rows (color swatch + label + value, already carrying the same numbers the bar
// chart visualized) are kept; the bar chart itself is dropped, flagged as a gap.
import React from 'react';
import {Box, Divider, Stack, Typography} from '@mui/material';
import {tokens} from '../../../themes/ThemeCustomization';

const EngagementStakeVisaStats = ({stakeVisaDebitInfo = {}}) => {
    const items = Array.isArray(stakeVisaDebitInfo.items) ? stakeVisaDebitInfo.items : [];
    const graph = stakeVisaDebitInfo.data && typeof stakeVisaDebitInfo.data === 'object' ? stakeVisaDebitInfo.data : {};
    const labels = stakeVisaDebitInfo.labels || {};
    const colors = stakeVisaDebitInfo.colors || {};
    const graphKeys = Object.keys(graph);

    if (!stakeVisaDebitInfo.data) return null;

    return (
        <Box sx={{flex: 1, border: `1px solid ${tokens.color.neutral200}`, borderRadius: '6px', backgroundColor: tokens.color.white, p: 2}}>
            <Stack spacing={1.5}>
                <Typography variant="subtitle1" fontWeight={600}>
                    {stakeVisaDebitInfo.title ?? ''}
                </Typography>
                <Stack direction="row" divider={<Divider orientation="vertical" flexItem />} sx={{border: `1px solid ${tokens.color.neutral200}`, borderRadius: '6px'}}>
                    {items.map((entry, index) => (
                        <Stack key={index} sx={{flex: 1, p: 1.5}}>
                            <Typography variant="subtitle1" fontWeight={600}>
                                {entry.metric}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                {entry.label}
                            </Typography>
                        </Stack>
                    ))}
                </Stack>
                <Stack spacing={1} divider={<Divider />}>
                    {graphKeys.map((name) => {
                        const label = name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
                        return (
                            <Stack key={name} direction="row" alignItems="center" spacing={1}>
                                <Box sx={{width: 12, height: 12, borderRadius: '2px', backgroundColor: colors[name] || tokens.color.neutral300}} />
                                <Typography variant="body2" sx={{flex: 1}}>
                                    {label}
                                </Typography>
                                <Typography variant="body2" fontWeight={600}>
                                    {labels[name]}
                                </Typography>
                            </Stack>
                        );
                    })}
                </Stack>
            </Stack>
        </Box>
    );
};

export default EngagementStakeVisaStats;
